"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partition = void 0;
function partition(list, predicate) {
    return list.reduce(([pass, fail], item) => {
        if (predicate(item)) {
            pass.push(item);
        }
        else {
            fail.push(item);
        }
        return [pass, fail];
    }, [[], []]);
}
exports.partition = partition;
//# sourceMappingURL=partition.js.map